/**
 * MIDI Context — one shared Web MIDI session across the whole app.
 * Wraps `useMidi` so /studio and /settings see the same connected devices,
 * mappings, and subscriber queue.
 */
import React, { createContext, useContext } from "react";
import { useMidi } from "@/lib/midi/useMidi";

const MidiContext = createContext(null);

export function MidiProvider({ children }) {
  const midi = useMidi();
  return <MidiContext.Provider value={midi}>{children}</MidiContext.Provider>;
}

export function useMidiContext() {
  const ctx = useContext(MidiContext);
  if (!ctx) throw new Error("useMidiContext must be inside <MidiProvider>");
  return ctx;
}
